export default "__VITE_ASSET__Bj03wa2H__"